"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

var _LinkPopoverDecorator = _interopRequireDefault(require("./LinkPopoverDecorator"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var LinkComponent = (0, _createReactClass.default)({
  displayName: "LinkComponent",
  propTypes: {
    entityKey: _propTypes.default.string.isRequired,
    contentState: _propTypes.default.instanceOf(_draftJs.ContentState),
    togglePopover: _propTypes.default.func.isRequired,
    children: _propTypes.default.node
  },
  contextTypes: {
    getReadOnly: _propTypes.default.func.isRequired
  },
  getEntity: function getEntity() {
    var _this$props = this.props,
        entityKey = _this$props.entityKey,
        contentState = _this$props.contentState;
    return contentState.getEntity(entityKey);
  },
  handleClick: function handleClick(e) {
    var togglePopover = this.props.togglePopover;
    var getReadOnly = this.context.getReadOnly;

    if (getReadOnly()) {
      return;
    }

    e.preventDefault();
    togglePopover();
  },
  render: function render() {
    var _this$getEntity$getDa = this.getEntity().getData(),
        isNoFollow = _this$getEntity$getDa.isNoFollow,
        isTargetBlank = _this$getEntity$getDa.isTargetBlank,
        url = _this$getEntity$getDa.url;

    var target = isTargetBlank ? '_blank' : '_self';
    var rel = isNoFollow ? 'nofollow' : null;
    return _react.default.createElement(_UILink.default, {
      href: url,
      onClick: this.handleClick,
      rel: rel,
      target: target
    }, this.props.children);
  }
});

var _default = (0, _LinkPopoverDecorator.default)(LinkComponent);

exports.default = _default;
module.exports = exports.default;